<template>
	<div class="accordion page">
		<div>
			Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
			sed diam nonumy eirmod tempor invidunt ut labore et dolore.
		</div>
		<transition-expand>
			<div v-if="expanded">
				Magna aliquyam erat, sed diam voluptua. At vero eos et
				accusam et justo duo dolores et ea rebum. Stet clita.
				Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ipsam inventore beatae officiis esse nihil assumenda fugit praesentium aspernatur libero reprehenderit quaerat vel vero, neque quo dolore atque magnam commodi in sequi dolor a cupiditate quis? Sunt omnis ducimus at tempora.
			</div>
		</transition-expand>

		<button @click="expanded = !expanded">{{ expanded ? `Shrink` : `Expand` }}</button>
	</div>
</template>
<script>
import transitionExpand from "@/components/TransitionExpand.vue";

export default {
    name: 'accoridon',
	components: {
		transitionExpand
	},
	data() {
		return {
			expanded: false
		};
	}
};
</script>
